document.addEventListener('DOMContentLoaded', () => {
  // =============== START: FAQS Js ==================//
  const accordions = document.querySelectorAll('.collapsible-content details');
  accordions.forEach((accordion) => {
    accordion.addEventListener('toggle', function () {
      if (this.open) {
        accordions.forEach((item) => {
          if (item !== this) {
            item.removeAttribute('open');
          }
        });
      }
    });
  });
  // =============== END: FAQS Js ==================//

  // =============== START: product Delivery Timer Js ==================//
  document.querySelectorAll(".delivery-timer").forEach(function (timer) {

    function updateTimer() {
      // Current time in UK (London)
      const now = new Date();

      const ukNow = new Date(
        now.toLocaleString("en-US", { timeZone: "Europe/London" })
      );

      // Target: Today at 12:00 PM UK time
      const target = new Date(ukNow);
      target.setHours(12, 0, 0, 0);

      // If it's already past 12 PM, target tomorrow
      if (ukNow >= target) {
        target.setDate(target.getDate() + 1);
      }

      const remaining = target - ukNow;

      const hours = Math.floor(remaining / (1000 * 60 * 60));
      const minutes = Math.floor(
        (remaining % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor(
        (remaining % (1000 * 60)) / 1000
      );

      timer.textContent =
        String(hours).padStart(2, "0") + ":" +
        String(minutes).padStart(2, "0") + ":" +
        String(seconds).padStart(2, "0");
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  });
  // =============== END: product Delivery Timer Js ==================//
  // =============== Start: Bundle Product Js ==================//
  document.querySelectorAll('[data-bundle-offer-section]').forEach((section) => {
    if (section.dataset.bundleOfferInitialized === 'true') return;
    section.dataset.bundleOfferInitialized = 'true';

    const $ = (s, p = section) => p.querySelector(s);
    const $$ = (s, p = section) => [...p.querySelectorAll(s)];

    const addButton = $('[data-bundle-offer-add]');
    if (!addButton) return;

    const tiers = $$('.bundle-offer-tier');
    const rows = $$('[data-bundle-offer-variant-row]');
    const selects = $$('.bundle-offer-variant__select');
    const customSelects = $$('[data-custom-variant-select]');

    const buy2Discount = Number(section.dataset.bundleOfferBuy2Discount ?? section.dataset.buy2Discount ?? 15);
    const buy5Discount = Number(section.dataset.bundleOfferBuy5Discount ?? section.dataset.buy5Discount ?? 25);

    let variants = [];

    try {
      variants = JSON.parse(
        $('[data-bundle-offer-variants-data]')?.textContent || '[]'
      );
    } catch (error) {
      console.error('Bundle Offer: Invalid variant data.', error);
      return;
    }

    if (!variants.length) {
      console.warn('Bundle Offer: No product variants found.');
      return;
    }

    const firstVariant =
      variants.find((variant) => variant.available) || variants[0];

    // --------------------  Variant helpers ----------------------

    const getOptions = (row) =>
      $$('.bundle-offer-variant__select', row).map((select) => select.value);

    const findVariant = (row) => {
      const options = getOptions(row);

      return variants.find((variant) =>
        options.every((value, index) => variant.options[index] === value)
      ) || null;
    };

    const updateCustomSelect = (row, index, value) => {
      const custom = $(
        `[data-custom-variant-select][data-option-index="${index}"]`,
        row
      );

      if (!custom) return;

      $('[data-selected-value]', custom)?.replaceChildren(value);

      $$('[data-custom-select-option]', custom).forEach((option) => {
        option.classList.toggle('is-selected', option.dataset.value === value);
      });

      const imageContainer = $('.bundle-offer-variant__selected-image', custom);
      const image = $$('[data-custom-select-option]', custom)
        .find((option) => option.dataset.value === value)
        ?.querySelector('img');

      if (imageContainer) {
        imageContainer.replaceChildren(image?.cloneNode(true) || '');
      }
    };

    const updateSizeStock = (row) => {
      const color = $(
        '.bundle-offer-variant__select[data-option-index="0"]',
        row
      )?.value;

      const sizeSelect = $(
        '[data-custom-variant-select][data-option-index="1"]',
        row
      );

      if (!color || !sizeSelect) return;

      $$('[data-custom-select-option]', sizeSelect).forEach((option) => {
        const value = option.dataset.value;

        const available = variants.some(
          (variant) =>
            variant.available &&
            variant.options[0] === color &&
            variant.options[1] === value
        );

        option.classList.toggle('is-disabled', !available);
      });
    };

    const setRowVariant = (row, variant) => {
      if (!variant) return;

      $$('.bundle-offer-variant__select', row).forEach((select) => {
        const index = Number(select.dataset.optionIndex);
        const value = variant.options[index];

        if (!value) return;

        if ([...select.options].some((option) => option.value === value)) {
          select.value = value;
          updateCustomSelect(row, index, value);
        }
      });

      row.dataset.variantId = variant.id;
      updateSizeStock(row);
    };

    const getRowVariant = (row) => {
      const variant = findVariant(row);

      if (variant) row.dataset.variantId = variant.id;

      return variant;
    };

    // ----------------------- Tier helpers  ---------------------------

    const getTier = () =>
      Number($('[data-bundle-tier-radio]:checked')?.value || 2);

    const getRows = (tier) =>
      $$(
        `[data-bundle-tier="${tier}"] [data-bundle-offer-variant-row]`
      );

    const getVariants = (tier) =>
      tier === 1
        ? [firstVariant]
        : getRows(tier).map(getRowVariant).filter(Boolean);

    // ---------------------- Pricing ------------------------

    const money = (cents) =>
      new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'INR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Number(cents) / 100);

    const updatePrice = (tier, selected, discount = 0) => {
      const element = $(`[data-bundle-tier-price="${tier}"]`);

      if (!element || !selected.length) return;

      const subtotal = selected.reduce(
        (total, variant) => total + Number(variant.price || 0),
        0
      );

      element.textContent = money(
        tier === 1 ? selected[0].price : subtotal * (1 - discount / 100)
      );
    };

    const updatePrices = () => {
      updatePrice(1, [firstVariant]);
      updatePrice(2, getVariants(2), buy2Discount);
      updatePrice(5, getVariants(5), buy5Discount);
    };

    // --------------------------- Tier UI ----------------------------

    const updateTierUI = () => {
      const selectedTier = getTier();

      tiers.forEach((tier) => {
        tier.classList.toggle(
          'is-selected',
          Number(tier.dataset.bundleTier) === selectedTier
        );
      });

      updatePrices();
    };

    tiers.forEach((tier) => {
      const header = $('.bundle-offer-tier__header', tier);
      const radio = $('[data-bundle-tier-radio]', tier);

      header?.addEventListener('click', (event) => {
        if (event.target.closest('.bundle-offer-variant__select')) return;

        radio.checked = true;
        updateTierUI();
      });
    });

    // ----------------------------- Initialize rows ------------------------------

    rows.forEach((row) => setRowVariant(row, firstVariant));

    // ------------------------------- Custom selects ---------------------------

    const closeSelects = (except = null) => {
      customSelects.forEach((select) => {
        if (select !== except) select.classList.remove('is-open');
      });
    };

    customSelects.forEach((custom) => {
      const trigger = $('[data-custom-select-trigger]', custom);

      trigger?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const open = custom.classList.contains('is-open');

        closeSelects(custom);
        custom.classList.toggle('is-open', !open);
      });

      $$('[data-custom-select-option]', custom).forEach((option) => {
        option.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const row = custom.closest('[data-bundle-offer-variant-row]');
          const value = option.dataset.value;
          const index = Number(custom.dataset.optionIndex);

          if (!row || value === undefined) return;

          updateCustomSelect(row, index, value);

          const select = $(
            `.bundle-offer-variant__select[data-option-index="${index}"]`,
            row
          );

          if (select && select.value !== value) {
            select.value = value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }

          custom.classList.remove('is-open');
        });
      });
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-custom-variant-select]')) {
        closeSelects();
      }
    });

    // ----------------------- Native selects ------------------------

    selects.forEach((select) => {
      select.addEventListener('change', () => {
        const row = select.closest('[data-bundle-offer-variant-row]');
        if (!row) return;

        let variant = findVariant(row);

        if (!variant) {
          const index = Number(select.dataset.optionIndex);

          variant = variants.find(
            (item) =>
              item.available &&
              item.options[index] === select.value
          );

          if (variant) setRowVariant(row, variant);
        } else {
          row.dataset.variantId = variant.id;
        }

        updateSizeStock(row);
        updatePrices();
      });
    });

    // -------------------------- Swiper -------------------------

    const swiper = $('.bundle-offer-swiper');

    if (swiper && typeof Swiper !== 'undefined' && !swiper.swiper) {
      new Swiper(swiper, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 400,
        grabCursor: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: $('.bundle-swiper-next', swiper.parentElement),
          prevEl: $('.bundle-swiper-prev', swiper.parentElement)
        },
        pagination: {
          el: $('.bundle-swiper-pagination', swiper.parentElement),
          clickable: true
        }
      });
    }

    // --------------------------- Cart ---------------------------

    const addToCart = async (selectedVariants, tier) => {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/add.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: selectedVariants.map((variant) => ({
              id: Number(variant.id),
              quantity: 1,
              properties: {
                '_Bundle Offer': `Buy ${tier}`
              }
            }))
          })
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.description ||
          data.message ||
          'Unable to add items to cart.'
        );
      }

      return data;
    };

    const getCart = async () => {
      try {
        const response = await fetch(
          `${window.Shopify.routes.root}cart.js`,
          { headers: { Accept: 'application/json' } }
        );

        return response.ok ? response.json() : null;
      } catch {
        return null;
      }
    };

    const updateCartCount = (cart) => {
      if (!cart) return;

      document
        .querySelectorAll(
          '.cart-count, .cart-drawer__count, [data-cart-count]'
        )
        .forEach((element) => {
          element.textContent = cart.item_count;
        });
    };

    const openCartDrawer = async () => {
      const drawer = document.getElementById('Cart-Drawer');

      if (!drawer) {
        console.error('Bundle Offer: #Cart-Drawer not found.');
        return;
      }

      dispatchCustomEvent('cart:refresh');

      await new Promise((resolve) => setTimeout(resolve, 500));

      if (typeof OverlayManager !== 'undefined') {
        OverlayManager.open(drawer);
      }

      dispatchCustomEvent('cart-drawer:open');
    };

    // -------------------------------- Add bundle --------------------------------

    addButton.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (addButton.disabled) return;

      const tier = getTier();
      const selected = getVariants(tier);
      const required = tier === 1 ? 1 : tier === 2 ? 2 : 5;

      if (selected.length !== required) {
        alert(
          tier === 2
            ? 'Please select variants for both products.'
            : tier === 5
              ? 'Please select variants for all 5 products.'
              : 'Please select a product variant.'
        );
        return;
      }

      if (selected.some((variant) => !variant.available)) {
        alert('One or more selected variants are unavailable.');
        return;
      }

      addButton.disabled = true;
      addButton.classList.add('loading');

      try {
        await addToCart(selected, tier);

        const cart = await getCart();

        updateCartCount(cart);
        await openCartDrawer();
      } catch (error) {
        console.error('Bundle Offer Add to Cart Error:', error);

        alert(
          error.message ||
          'Something went wrong while adding the product to cart.'
        );
      } finally {
        addButton.disabled = false;
        addButton.classList.remove('loading');
      }
    });

    // ------------------------ Initial state ------------------------
    updateTierUI();
  });

  // =============== End: Bundle Product Js ==================//

  // =========== Start: Free Shipping Bar Js ============= //
  (function () {
    'use strict';

    if (window.__cwFreeShippingLoaded) return;
    window.__cwFreeShippingLoaded = true;

    var updateTimer = null;
    var lastTotal = null;
    var requestId = 0;

    function updateFreeShipping() {
      var bar = document.getElementById('cw-free-shipping');
      if (!bar) return;

      var threshold = Number(bar.dataset.threshold);
      if (!threshold) return;

      var currentRequest = ++requestId;

      fetch((window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root
        : '/') + 'cart.js', {
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart request failed');
          return response.json();
        })
        .then(function (cart) {
          if (currentRequest !== requestId) return;

          var currentBar = document.getElementById('cw-free-shipping');
          if (!currentBar) return;

          var total = Number(cart.total_price) || 0;
          if (total === lastTotal) return;

          lastTotal = total;

          var progress = Math.max(
            0,
            Math.min((total / threshold) * 100, 100)
          );

          var fill = currentBar.querySelector('.cw-free-shipping__fill');
          var track = currentBar.querySelector('.cw-free-shipping__track');
          if (fill) {
            fill.style.width = progress + '%';
          }

          if (track) {
            track.setAttribute(
              'aria-valuenow',
              Math.min(total, threshold)
            );
          }
        })
        .catch(function (error) {
          console.warn('Free shipping update failed:', error);
        });
    }

    function scheduleUpdate() {
      clearTimeout(updateTimer);
      updateTimer = setTimeout(updateFreeShipping, 300);
    }

    document.addEventListener('cart:updated', scheduleUpdate);
    document.addEventListener('cart:refresh', scheduleUpdate);
    document.addEventListener('cart:rendered', scheduleUpdate);

    var originalFetch = window.fetch;

    window.fetch = function () {
      var args = arguments;
      var url = typeof args[0] === 'string'
        ? args[0]
        : (args[0] && args[0].url) || '';

      return originalFetch.apply(this, args).then(function (response) {
        if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)) {
          scheduleUpdate();
        }

        return response;
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateFreeShipping, {
        once: true
      });
    } else {
      updateFreeShipping();
    }
  })();
  // =========== End: Free Shipping Bar Js ============= //
  
});




  // =============== Start : Listicle-page Js ==================//

document.addEventListener('click', function (e) {
  const button = e.target.closest(
    '.template-page-listicle-page .listicle-three-image-text a.button.btn--blue'
  );

  if (!button) return;

  e.preventDefault();

  // Button hide
  button.style.display = 'none';

  const section = button.closest('.listicle-three-image-text');

  const description = section.querySelector(
    '.rte.description-size--medium:last-child'
  );

  if (description) {
    // Description show
    description.style.display = 'block';
  }
});


  // =============== End : Listicle-page Js ==================//

  // =============== Start : Navigation Megamenu Js ==================//
  document.querySelectorAll('.thb-full-menu li.menu-item-has-children').forEach(function (menuItem) {
    menuItem.addEventListener('mouseenter', function () {
      document.body.classList.add('active_megamenu');
    });
    menuItem.addEventListener('mouseleave', function () {
      document.body.classList.remove('active_megamenu');
    });
  });
  // =============== Start : Navigation Megamenu Js ==================//